"use client";

import React from "react";
import styled from "styled-components";
import { LayoutProps } from "../types";
import { LogoFullCu } from "@/components/ui/logo-cu";
import { desktop } from "@/theme/common";

/**
 * Styled Components
 */

const MainContainer = styled.main`
  min-height: 100vh;
  background-color: ${({ theme }) => theme.Colors.white};
  display: flex;
  flex-direction: column;
`;

const Content = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px 32px;
  border-bottom: 1px solid #eee;

  ${desktop(`
    justify-content: flex-start;
  `)};
`;

/**
 * PublicLayout Component
 */

export const PublicLayout = ({ children }: LayoutProps) => (
  <MainContainer>
    <Content>
      <LogoFullCu size={170} />
    </Content>
    {children}
  </MainContainer>
);
